import { ElementType } from '../parsing/parser';
import type { FieldId, FormElementSchema } from '../types';

/**
 * Every field id under a subtree, in the order the form renders them.
 *
 * Shared because two features need the same walk — the section-level draft
 * controls and the broker snapshot — and a second copy would publish a
 * different field set than the controls act on the moment a new `ElementType`
 * lands.
 */
export function collectFieldIds(
  elements: readonly FormElementSchema[],
  into: FieldId[] = []
): FieldId[] {
  elements.forEach((element) => {
    if (element.type === ElementType.Field) {
      into.push(element.fieldId);
      return;
    }
    collectFieldIds(element.elements, into);
  });
  return into;
}
